import React from 'react'
import { AlertTriangle, X } from 'lucide-react'

function DisclaimerModal({ onAccept, onDecline }) {
  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-modal">
        <div className="disclaimer-header">
          <AlertTriangle size={24} className="disclaimer-icon" />
          <h2>Disclaimer</h2>
          <button className="disclaimer-close" onClick={onDecline}>
            <X size={20} />
          </button>
        </div>

        <div className="disclaimer-content">
          <p className="disclaimer-text">
            This tool is <strong>not an Oracle product</strong>, and it is not affiliated with or endorsed by Oracle Corporation. 
            Oracle Cloud Infrastructure (OCI) and Oracle are registered trademarks of Oracle Corporation. 
            All rights to these trademarks are reserved by Oracle.
          </p>

          <p className="disclaimer-text">
            The use of this tool is entirely <strong>at your own risk</strong>. Neither the developer of this tool nor 
            Oracle Corporation shall be held liable for any outcomes, including but not limited to, data loss, 
            system failures, or any other issues that may arise from the use of this tool.
          </p>

          <div className="disclaimer-agreement">
            <p>
              By clicking <strong>"I Agree"</strong> below, you acknowledge that you have read and understood 
              this disclaimer, and you agree to take full responsibility for any actions and outcomes 
              resulting from the use of this tool.
            </p>
          </div>
        </div>

        <div className="disclaimer-footer">
          <button className="btn btn-secondary" onClick={onDecline}>
            Decline
          </button>
          <button className="btn btn-primary" onClick={onAccept}>
            I Agree
          </button>
        </div>
      </div>
    </div>
  )
}

export default DisclaimerModal
